module.exports = __webpack_public_path__ + "img/package.1c02305d.png";